<template>
  <div>
    <el-checkbox
      v-model="checkAll"
      @change="handleCheckAllChange"
      :disabled="disabled"
      v-show="options.length > 0"
      >全选</el-checkbox
    >
    <div style="margin: 15px 0"></div>
    <el-checkbox-group v-model="checked" @change="handleCheckedChange">
      <el-checkbox
        v-for="item in options"
        :disabled="disabled"
        :label="item.id"
        :key="item.id"
        :value="item.id"
        >{{ item.name }}</el-checkbox
      >
    </el-checkbox-group>
    <el-button
      style="margin-top: 20px"
      size="small"
      type="primary"
      class="mobile-ml-0"
      @click="submit"
      v-show="options.length > 0"
      >保 存</el-button
    >
  </div>
</template>
<script>
import { setResource, setUserResource } from '@/service/getData'
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rkey: '',
    userID: '',
  },
  created() {
    this.checked = this.value
    this.handleCheckedChange(this.checked)
  },
  watch: {
    value: function (v) {
      this.checked = v
      this.handleCheckedChange(v)
    },
  },
  data() {
    return {
      checkAll: false,
      checked: [],
    }
  },
  methods: {
    handleCheckAllChange(val) {
      this.checked = val
        ? this.options.map((item) => {
            return item.id
          })
        : []
      // this.$emit('change', this.checked)
    },
    handleCheckedChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.options.length
      // this.$emit('change', this.checked)
    },

    async submit() {
      let data = {
        key: this.rkey,
        value: this.checked,
        data: [],
        user_id: parseInt(this.userID),
      }

      if (this.category != 2) {
        data.data = this.options
          .filter((item) => this.checked.includes(item.id))
          .map((item) => {
            return { name: item.name, value: item.id.toString() }
          })
      }

      let res = {}
      if (this.category == 2) {
        data.area_id = parseInt(data.key)
        data.key = 'user'
        data.all_area = this.disabled ? 1 : 0
        res = await setUserResource(data)
      } else {
        res = await setResource(data)
      }
      if (res.code == 0) {
        this.$emit('saveCallback', this.checked)
        this.$message({
          message: '保存成功',
          type: 'success',
        })
      }
    },
  },
}
</script>